// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const INSTAGRAM_POST_DELETED = "(smaz\u00e1no)";
